import {loadingDialog_show} from "../../actions";
import {getApiConfig, getNextMaxNumberFromList} from "../../utilities";
import * as actions from "../../actions/A_Popups";
import {setContractsList, updateContractsList} from "./contractsActions";

export const getContracts = (propsFabricatorId) => {
  return (dispatch, getState) => {

    const {auth, asCustomer} = getState();

    dispatch(setContractsList([]));
    dispatch(actions.loadingDialog_show(true, 'Loading...', 'Please wait while contracts are loaded.'));

    const fabricatorId = propsFabricatorId || (asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId);

    return getApiConfig('document-signing/documents/').get(fabricatorId)
      .then((response) => {
        console.log('response get contracts ->', response);
        dispatch(loadingDialog_show(false));
        if (Array.isArray(response)) {
          const newOrderedList = response
            .sort((a, b) => (a.order > b.order) ? 1 : -1)
            .map((contract, contractIndex) => {
              contract.order = contractIndex;
              return contract;
            });
          dispatch(setContractsList(newOrderedList))
        }
        return response
      })
      .catch((response) => {
        console.log('error get contracts ->', response);
        dispatch(loadingDialog_show(false));
        return false
      });
  }
};

//1)
export const analyzeContract = async (file, contractsList) => {

  const form = new FormData();
  form.append(file.name, file);

  const result = await getApiConfig(`document-signing/validate-pdf-document`).post(form);
  // documentFullUrl: null,
  // errors: [],
  // fields: [{name: "firstName", description: "firstName", isPresent: false, occurrencesCount: 0, coords: [],…},…]
  // masterDocumentExists: false
  // ok: true
  if (!result || !result.ok) {
    return false
  }
  return [...contractsList.map(cont => {
    cont.isActive = false;
    return cont
  }), {
    id: getNextMaxNumberFromList(contractsList, "id"),
    name: file.name,
    isActive: true,
    selected: false,
    isDefault: !contractsList.length,
    documentUrl: result.documentFullUrl,
    documentKey: "",
    fields: result.fields,
    order: contractsList.length,
    uploaded: false,
    file,
  }];
};

//2) upload not uploaded
export const uploadAndSaveContracts = (propsFabricatorId) => {
  return async (dispatch, getState) => {

    const {contractsState} = getState();
    const {contractsList} = contractsState;

    const {auth, asCustomer} = getState();
    const fabricatorId = propsFabricatorId || (asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId);

    dispatch(actions.loadingDialog_show(true, 'Uploading...', 'Please wait while contracts are uploaded.'));

    for (const contract of contractsList) {
      if (!contract.documentUrl && contract.file) { // needs to be uploaded
        const form = new FormData();
        form.append(contract.file.name, contract.file);
        const uploadResult = await getApiConfig(`document-signing/save-pdf-document/${fabricatorId}`).post(form);
        if (uploadResult && uploadResult.documentFullUrl) {
          contract.documentUrl = uploadResult.documentFullUrl;
          contract.id = uploadResult.id;
        }
      }
    }
    console.log("uploaded contractsList", contractsList);
    await saveContracts(dispatch, contractsList)
  }
};

//3) save with Urls
export const saveContracts = (dispatch, contractsList) => {

  dispatch(actions.loadingDialog_show(true, 'Saving...', 'Please wait while contracts are saved.'));

  const postContractsData = contractsList
    // .filter(contract => contract.documentUrl) // we need to upload all to be able to delete
    .map(contract => {
      return {
        "Id": contract.id,
        "Name": contract.name,
        "DocumentUrl": contract.documentUrl,
        "DocumentKey": contract.documentKey,
        "IsDefault": contract.isDefault,
        "Selected": false,
        "Order": contract.order,
        "Fields": contract.fields,
      }
    });

  return getApiConfig(`document-signing/documents`).post(postContractsData)
    .then((response) => {
      console.log('response save contracts ->', response);
      dispatch(loadingDialog_show(false));
      if (Array.isArray(response)) {
        dispatch(setContractsList(response))
      }
      return response
    })
    .catch((response) => {
      console.log('error save contracts ->', response);
      dispatch(loadingDialog_show(false));
      return false
    });
}

export const deleteContracts = () => {
  return async (dispatch, getState) => {

    const {contractsState} = getState();
    const {contractsList} = contractsState;

    const contractsToDelete = contractsList.filter(cont => cont.selected);
    const contractsToKeep = contractsList.filter(cont => !cont.selected);

    dispatch(actions.loadingDialog_show(true, 'Deleting...', 'Please wait while contracts are deleted.'));

    for (const contract of contractsToDelete) {
      if (contract.documentUrl) {
        await getApiConfig(`document-signing/documents/`).delete(contract.id);
      }
    }

    dispatch(actions.loadingDialog_show(false));
    dispatch(updateContractsList(contractsToKeep));
  }
};
